import script from "./ProcessingImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessingImage.vue?vue&type=script&setup=true&lang=js"

import "./ProcessingImage.vue?vue&type=style&index=0&id=bd96a134&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd96a134"]])

export default __exports__